import React, { useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import { X } from "lucide-react";

export function NewBoardModal({ onClose, onCreate }: { onClose: () => void; onCreate: (title: string) => void }) {
  const [title, setTitle] = useState("");

  const handleCreate = () => {
    const trimmed = title.trim();
    if (!trimmed) return;
    onCreate(trimmed);
    onClose();
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          className="bg-surface border border-border rounded-3xl p-6 max-w-md w-full shadow-2xl space-y-5"
        >
          <div>
            <h2 className="text-lg font-bold text-content mb-1">Créer un nouveau tableau</h2>
            <p className="text-sm text-content-muted">Donnez un titre à votre nouveau tableau de réservations (ex: "Nouvel An 2026-2027").</p>
          </div>

          <input
            type="text"
            placeholder="Titre du tableau"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            autoFocus
            onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
            className="w-full bg-surface-soft border border-border rounded-xl px-4 py-3 text-content outline-none focus:border-brand-500 transition-colors"
          />

          <div className="flex justify-end gap-3 pt-2">
            <button onClick={onClose} className="px-5 py-2.5 rounded-xl border border-border text-content-muted hover:text-content hover:bg-surface-soft font-bold text-sm transition-all">
              Annuler
            </button>
            <button onClick={handleCreate} disabled={!title.trim()} className="px-5 py-2.5 rounded-xl bg-brand-600 hover:bg-brand-700 disabled:opacity-50 text-brand-fg font-bold text-sm transition-all">
              Créer
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
